<template>
  <div class="container-ajust-budget p-4 m-2">
    <icon-view
      class="mt-2"
      icon="fa fa-file-invoice-dollar mb-1"
      icon-background="#ff745c"
      icon-color="#fff"
      icon-size="14px"
      title="Ajustar Presupuesto"
    />
    <validation-observer ref="adjustBudgetRef" novalidate tag="form">
      <div class="row mt-3">
        <div class="col-md-5 col-sm-12 mt-3 mt-md-0">
          <p class="label-gray p-label" style="margin-left: 8px">
            ¿Que tipo de ajuste desea realizar?
          </p>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-radio-button
              id="CustomRadioTypeAdjust"
              v-model="isIncrement"
              custom-error-msg="Debe especificar si es un aumento o reducción."
              :error="errors[0]"
              :is-disabled="false"
              is-inline
              label=""
              name="compuOptions"
              :options="options"
            />
          </validation-provider>
        </div>
        <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
          <p class="label-gray p-label">Cantidad:</p>
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              greaterThanZero: 'La cantidad debe ser mayor que 0.',
              required: 'La cantidad es requerida.',
            }"
            rules="required|greaterThanZero"
          >
            <custom-input
              id="txtQuantityBudget"
              v-model="newAmount"
              :error="errors[0]"
              :icon-background-class="
                isIncrement
                  ? 'adjust-background-green'
                  : 'adjust-background-red'
              "
              placeholder="$0.00"
              :prepend-icon="
                isIncrement
                  ? 'fas fa-plus icon-color icon-font'
                  : 'fas fa-minus icon-color icon-font'
              "
              :prepend-icon-left="true"
              type="number"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-12 mt-md-0">
          <div class="container-text-aviable">
            <p class="p-label label-gray">Nuevo Total Disponible:</p>
            <strong :class="isPositiveAdjustment ? 'positive' : 'negative'">
              {{ formatCurrency(totalAmount) }}
            </strong>
          </div>
        </div>

        <div class="col-md-12 m-3" />
      </div>
      <div class="row">
        <div class="col-md-2 mt-md-0" />
        <div class="col-md-4 mt-md-0" />
        <div class="col-md-6 mt-md-0 d-flex justify-content-end">
          <div class="container-buttons">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-md-2 mb-2 px-4"
              @click="onCancelHandler"
            />
            <action-button
              i="fas fa-save"
              text="Guardar"
              variant="success px-4"
              @click="onSaveBudget"
            />
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import IconView from 'icon-view';
import { ValidationObserver } from 'vee-validate';
import CustomRadioButton from 'custom-radio';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';

export default {
  name: 'AjustBudget',
  components: {
    CustomRadioButton,

    ActionButton,
    CustomInput,
    ValidationObserver,
    IconView,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data: () => ({
    options: [
      {
        label: 'Aumentar Presupuesto',
        value: true,
      },
      {
        label: 'Reducir Presupuesto',
        value: false,
      },
    ],
    isIncrement: true,
    newAmount: null,
  }),
  computed: {
    totalAmount() {
      let newAmnt =
        this.newAmount != null ? Number.parseFloat(this.newAmount) : 0;
      if (!this.isIncrement) newAmnt *= -1;

      return this.item.budget + newAmnt;
    },
    isPositiveAdjustment() {
      return this.totalAmount >= 0;
    },
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onSaveBudget() {
      const isValid = await this.$refs.adjustBudgetRef.validate();
      if (!isValid) {
        return;
      }

      const adjustBudget = {
        id: this.item.id,
        period: this.item.period,
        amount: Number.parseFloat(this.newAmount),
      };

      if (!this.isIncrement) adjustBudget.amount *= -1;

      this.$emit('on-save', adjustBudget);
    },
  },
};
</script>
<style scopped lang="scss">
.p-label {
  font-size: 14px;
}
.container-ajust-budget {
  background-color: white;
  border-radius: 5px;
}
.positive {
  color: #2db782;
}
.negative {
  color: red;
}
.adjust-background-green {
  background-color: var(--green);
}
.adjust-background-red {
  background-color: var(--red);
}
.icon-font {
  color: var(--white);
  font-weight: 400;
}
.label-gray {
  color: #727272;
}
.container-text-aviable {
  margin-left: 45%;
}
.container-buttons {
  margin-left: 228px;
}
</style>
